module.exports = __webpack_public_path__ + "img/DAVID_CANNON_40-rs.ced93a95.jpg";